import {EnrollParents} from "./enroll-parents";

export class EnrollPersonalInfo {
  enroll_photo: string = '';
  surname: string = '';
  firstname: string = '';
  patronymic: string = '';
  fullName: string;
  surname_translit: string = '';
  firstname_translit: string = '';
  birth_date: Date = new Date();
  iin: string = '';
  iin_gived_gosorgan: boolean = false;
  sex: number = null;
  nationality: number = null;
  martial_status: number = null;
  citizenship: number = 113;
  country_of_arrival: number = null;
  city_of_arrival: string = '';
  birth_place: string = '';
  born_in_other_country: boolean = false;
  other_country_birth_place: string = '';
  reg_place: string = '';
  reg_address: string = '';
  living_place: string = '';
  living_address: string = '';
  parents: EnrollParents[] = [];
  has_iin: number = 1;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-personal-info.ts